export default Object.freeze({
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  INACTIVE: "INACTIVE",
  CANCELED: "CANCELED"
})